import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Observable } from 'rxjs';

import { CloudFeatureFlagsInitializationService } from './cloud-feature-flags-initialization.service';

export interface InitializeFeatureFlagsGuardOptions {
	/**
	 * If true, will wait for the user profile to load and use it to set the Statsig user.
	 * NOTE: If using this option, make sure you are also using the OktaAuthGuard and oktaSessionGuard.
	 * E.g. canActivate: [OktaAuthGuard, oktaSessionGuard, initializeFeatureFlagGuard({ setUserConfig: true )]
	 */
	setUserConfig?: boolean;
}

/**
 * Guard that will wait for Statsig to load (optionally setting the user as well) before activating
 */
export function initializeFeatureFlagsGuard(options: InitializeFeatureFlagsGuardOptions = {}): CanActivateFn {
	return (): Observable<boolean> => {
		const initilizationService = inject(CloudFeatureFlagsInitializationService);
		return initilizationService.initialize$(!!options.setUserConfig);
	};
}
